// extracted by mini-css-extract-plugin
module.exports = {"togglePanel":"TogglePanel_togglePanel__3uGqL"};